<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <shift-edit-form @on-submit="onShiftEditSubmit"></shift-edit-form>
    </div>
  </div>
</template>
<script>
import ShiftEditForm from "./ShiftEditForm.vue";

export default {
  components: {
    ShiftEditForm
  },
  data() {
    return {
      shiftEditModel: {}
    };
  },
  methods: {
    onShiftEditSubmit(model) {
      this.shiftEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'shifts/' + this.shiftEditModel.id, Object.assign(this.shiftEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
